<div class="row m-0 h-100 row-container">


    <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
        <app-admin-sidebar></app-admin-sidebar>
    </div>
    <div class="col-md-10 big-area p-0">

        <div class="wrapperi">

            <div class="col-12 p-0 row m-0">
                <div class="col-1"></div>
                <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
                    <h2>Artikkelit mobiiliapp</h2>
                    <p>Päivittäessä odota <strong>kärsivällisesti</strong>, kunnes saat palvelimelta hyväksyvän tai hylkäävän vastauksen. Alla näet artikkelit, jotka ovat näkyvissä mobiiliappissa.</p>
                    <button class="btn btn-formed-main-blue" (click)="updateArticles()"><span *ngIf="isLoading" class="spinner-border me-2 text-sm"></span>Päivitä artikkelit</button>

                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <td>Nimi</td>
                                <td>Linkki artikkeliin</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of articles">
                                <td>
                                        {{data.title['rendered']}}
 
                                
                                </td>
                                <td><p (click)="openLink(data.link)"
                                        class="btn btn-success me-4">Avaa linkki</p>
                                    </td>

                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-1"></div>
            </div>

        </div>

    </div>

